
// styles import
import authStyles from "./auth.module.css";
// libraries import
import { Form, Input } from "antd";
import { CheckCircleOutlined, LoadingOutlined, LockOutlined } from "@ant-design/icons";
import { useEffect, useState } from "react";


// context import
// endpoints import





import axios from "axios";

import AuthCarousel from "../../components/AuthCarousel";
import { useSearchParams } from "react-router-dom";
import { app } from "../../config";

const CreatePassword = () => {
    const [indx, setIndx] = useState(0);
    const [searchParams] = useSearchParams();

    
    const [linkedError, setLinkedError] = useState(null);
    const [encodedData, setEncodedData] = useState();
   
    const [focused, setFocused] = useState("");
    const [passwordError, setPasswordError] = useState("");
    const [loader, setLoader] = useState(false);
    const [form] = Form.useForm();
    const data = searchParams.get("data");
    console.log(data);

    // useEffect(() => {
    //     if (data) {
    //         let stringfyDecodedData = atob(data);
    //         let decodedData = JSON?.parse(stringfyDecodedData);

    //         console.log("YES I AM DATA", decodedData);
    //         // getInvoiceData(decodedData, data);
    //     }
    // }, []);
    useEffect(() => {
        if (data) {
            let stringfyDecodedData = atob(data);
            let decodedData = JSON?.parse(stringfyDecodedData);

            console.log(typeof decodedData);
            if (decodedData !== null && typeof decodedData === "object") {
                if (
                    decodedData?.orderNo &&
                    decodedData?.patientId &&
                    decodedData?.recordId
                ) {
                    console.log(decodedData);
                    setEncodedData(decodedData);
                } else {
                    setLinkedError("Invalid Link");
                }
            } else {
                setLinkedError("Invalid Link");
            }
        } else {
            setLinkedError("Invalid Link");
        }
    }, [data]);

    const onFinish = async (values) => {
        console.log("VALUES", values);

        setLoader(true);
        try {
            const res = await axios.get(
                `${app.URL}/api/v1/app/pdf-refer/verify?password=${values?.password}&recordId=${encodedData?.recordId}&patientId=${encodedData?.patientId}`
            );

            setLoader(false);

            if (res?.data?.success) {
                form.resetFields(["password"]);
                console.log("form value after reset:", form.getFieldValue("password"));
                window.location.href = res?.data?.data?.pdf;
            } else {
                setPasswordError(res?.msg);
            }
        } catch (e) {
            console.log(e);
            setPasswordError(e?.response?.data?.msg);
            setLoader(false);
        }
    };

    const onFinishFailed = (errorInfo) => {
        console.log("Failed:", errorInfo);
    };
    return (
        <div className={authStyles.login}>
            <div className="container-fluid position-relative">
        
                <div className="row">
                    <AuthCarousel />

                    <div className={`col-lg-6 col-md-12 ${authStyles.authColumn}`}>
                        <Form
                            name="basic"
                            form={form}
                            onFinish={onFinish}
                            onFinishFailed={onFinishFailed}
                            autoComplete="off"
                            className="w-100 mt-4"
                        >
                            <InputFieldP
                                labelName="Enter Password "
                                focused={focused}
                                setFocused={setFocused}
                                placeholder="Enter Password"
                                name="password"
                                rules={[
                                    {
                                        required: true,
                                        message: "Please input your password!",
                                    },
                                ]}
                                onChange={() => setPasswordError("")}
                                prefix={<LockOutlined className="me-2" />}
                                bg="#fff"
                            />

                            <div className="position-relative">
                                {passwordError && (
                                    <span className="customError position-absolute">
                                        {passwordError}
                                    </span>
                                )}
                            </div>

                            <Form.Item>
                                <button
                                    className="w-100 outline-none main-button  mt-2"
                                    htmlType="submit"
                                    disabled={linkedError}

                                // disabled={loader}
                                >
                                    {loader ? <LoadingOutlined /> : <>{"Submit"}</>}
                                </button>
                            </Form.Item>
                        </Form>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default CreatePassword;


export const InputFieldP = ({
    name,
    rules,
    placeholder,
    readOnly,
    disabled,
    focused,
    setFocused,
    labelName,
    prefix,
    bg,
    onChange,
    tooltip,
    showTooltip,
    setShowTooltip,
    passwordOk,
}) => {
    return (
        <div className="position-relative">
            {/* <label
        style={{
          position: "absolute",
          left: 10,
          top: focused === labelName ? -11 : 0,
          backgroundColor: bg ? bg : "rgb(246, 246, 246)",
          zIndex: 100,
          color: "#626262",
          padding: "0rem 0.2rem",
          fontSize: "0.8rem",
          opacity: focused === labelName ? 1 : 0,
        }}
      >
        {labelName}
      </label> */}

            <label
            className="mb-1"
                // style={{
                //     backgroundColor: bg ? bg : "rgb(246, 246, 246)",
                //     color: "#626262",
                //     fontSize: "0.9rem",
                // }}
            >
                {" "}
                {labelName}{" "}
            </label>

            <Form.Item name={name} rules={rules}>
                <Input.Password
                    name={name}
                    readOnly={readOnly}
                    //   bg-transparent
                    className=" input-field rounded-4"
                    placeholder={focused !== labelName ? placeholder : ""}
                    disabled={disabled}
                    onClick={() => setFocused(labelName)}
                    onMouseLeave={() => {
                        setFocused("");
                        if (tooltip) {
                            setShowTooltip(!showTooltip);
                        }
                    }}
                    prefix={prefix}
                    onChange={onChange}
                    onMouseEnter={() => {
                        if (tooltip) {
                            setShowTooltip(!showTooltip);
                        }
                    }}
                />
            </Form.Item>
            {tooltip && (
                <div
                    className="position-absolute mt-1 w-100  shadow-sm p-2 rounded"
                    style={{
                        right: 0,
                        opacity: showTooltip ? 1 : 0,
                        zIndex: showTooltip ? 1 : 0,
                        backgroundColor: "var(--white--)",
                        fontWeight: "bold",
                        fontSize: "0.8rem",
                        top: "100%",
                        color: passwordOk === true ? "green" : "black",
                    }}
                >
                    {[
                        "Password must contain at least one uppercase letter.",
                        "Password must contain at least one lowercase letter.",
                        "Password must contain at least one special character.",
                        "Password must contain at least one number.",
                        "Password atleast 8 charcharacters long.",
                    ].map((item) => (
                        <p className="m-0" key={item}>
                            <CheckCircleOutlined className="me-1" />
                            {item}
                        </p>
                    ))}
                </div>
            )}
        </div>
    );
};
